module.exports = __webpack_public_path__ + "media/images/lb/664-5e28df766028b3914a5d00ff2ecaf1f5.svg";